import { setSelectedChallengeProfile } from "../../reducers/exercice_zone/challengeProfile"
import { store } from "../../store/store"
import axios from "axios"

import { CHALLENGE_EXO_API_ROUTE } from "../../../routes/api/api_routes"


const challengeProfile = {
    createChallengeProfile(data){
        return new Promise((resolve,reject)=>{

            const config = {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              };

            axios.post(CHALLENGE_EXO_API_ROUTE,data,config)
            .then(response => {
                if(response.status === 201){
                    let challengeProfile = response.data
                    let dispatch = store.dispatch
                    dispatch(setSelectedChallengeProfile(challengeProfile))
                    resolve(challengeProfile)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
}
export default challengeProfile